import { useTranslation } from 'react-i18next';

import { Button } from 'src/components';
import { ActionButtonProps } from '../components.types';

const CancelButton = ({ text, ...rest }: ActionButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button fullWidth primary={false} sx={{ textTransform: 'capitalize', flex: 1 }} {...rest}>
      {text ?? t('companyDashboardPage.cancel')}
    </Button>
  );
};

export default CancelButton;
